module.exports = __webpack_public_path__ + "img/circle-half.ce3ed22e.svg";